jQuery(document).ready(function($){
    $('.product_slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      autoplay: true,
      autoplaySpeed: 3000,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 3 } },
        { breakpoint: 768, settings: { slidesToShow: 2 } },
        { breakpoint: 480, settings: { slidesToShow: 1 } }
      ]
    });
  });

jQuery(document).ready(function($){
    $('.about-logo-container').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      autoplay: false,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 3 } },
        { breakpoint: 768, settings: { slidesToShow: 2 } },
        { breakpoint: 480, settings: { slidesToShow: 1 } }
      ]
    });
  });

jQuery(document).ready(function($){
    $('.brand-home-image').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      autoplay: false,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 3 } },
        { breakpoint: 768, settings: { slidesToShow: 2 } },
        { breakpoint: 480, settings: { slidesToShow: 1 } }
      ]
    });
  });


jQuery(document).ready(function($){
    $('.brands-sliders').slick({
      slidesToShow: 8,
      centerMode: true,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      autoplay: false,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 8 } },
        { breakpoint: 768, settings: { slidesToShow: 3 } },
        { breakpoint: 480, settings: { slidesToShow: 2 } }
      ]
    });
  });




jQuery(document).ready(function($){
    $('.brand-slider-home').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      autoplay: false,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 3 } },
        { breakpoint: 768, settings: { slidesToShow: 2 } },
        { breakpoint: 480, settings: { slidesToShow: 1 } }
      ]
    });
  });




document.addEventListener("DOMContentLoaded", function () {

  // --- Desktop Only (1024px ya usse upar) ---
  if (window.innerWidth < 1024) return;  

  const mediaWrapper = document.querySelector('.single-product-page .product__media-list'); 
  const mediaItems = document.querySelectorAll('.single-product-page .product__media-item');

  if (!mediaWrapper || mediaItems.length <= 4) return;

  // Hide all items after 4 (Desktop only)
  mediaItems.forEach((item, index) => {
    if (index > 3) item.style.display = "none";
  });

  // Create Load More button
  const loadMoreBtn = document.createElement("button");
  loadMoreBtn.innerText = "Load More";
  loadMoreBtn.classList.add("product-more-btn");
  loadMoreBtn.style.cssText = "display:block; margin-top:10px;";

  // Create Show Less button
  const showLessBtn = document.createElement("button");
  showLessBtn.innerText = "Show Less";
  showLessBtn.classList.add("product-more-btn");
  showLessBtn.style.cssText = "display:none; margin-top:10px;";

  // Add buttons
  mediaWrapper.parentNode.appendChild(loadMoreBtn);
  mediaWrapper.parentNode.appendChild(showLessBtn);

  // Load More
  loadMoreBtn.addEventListener("click", function () {
    mediaItems.forEach(item => item.style.display = "block");
    loadMoreBtn.style.display = "none";
    showLessBtn.style.display = "block";
  });

  // Show Less
  showLessBtn.addEventListener("click", function () {
    mediaItems.forEach((item, index) => {
      item.style.display = (index > 3) ? "none" : "block";
    });
    loadMoreBtn.style.display = "block";
    showLessBtn.style.display = "none";
  });

});

document.addEventListener("DOMContentLoaded", function () {

  /* ================================
     FILTER ACCORDION (AUTO HEIGHT)
     ================================ */
  const headers = document.querySelectorAll(".filter-header");
  const contents = document.querySelectorAll(".filter-content");

  function closeAllAccordions() {
    headers.forEach(h => h.classList.remove("active"));
    contents.forEach(c => {
      c.style.maxHeight = null;
      c.style.overflow = "hidden";
    });
  }

  function openAccordion(header, content) {
    header.classList.add("active");
    content.style.maxHeight = content.scrollHeight + "px";

    /* allow natural height after animation */
    setTimeout(() => {
      content.style.maxHeight = "none";
      content.style.overflow = "visible";
    }, 300);
  }

  /* Open first filter by default */
  if (headers.length > 0) {
    openAccordion(headers[0], contents[0]);
  }

  headers.forEach((header, index) => {
    header.addEventListener("click", () => {
      const isOpen = header.classList.contains("active");

      closeAllAccordions();

      if (!isOpen) {
        openAccordion(header, contents[index]);
      }
    });
  });

  /* ================================
     MOBILE FILTER SIDEBAR + OVERLAY
     ================================ */
  const filterToggle = document.querySelector(".filter-toggle");
  const filterSidebar = document.querySelector(".filter-sidebar");
  const filterClose = document.querySelector(".filter-close");
  const overlay = document.querySelector(".overlay2");

  function openFilter() {
    filterSidebar.classList.add("active");
    overlay.classList.add("show");

    /* 🔒 lock background scroll */
    document.body.style.overflow = "hidden";
    document.body.style.touchAction = "none";
  }

  function closeFilter() {
    filterSidebar.classList.remove("active");
    overlay.classList.remove("show");

    /* 🔓 restore scroll */
    document.body.style.overflow = "";
    document.body.style.touchAction = "";
  }

  if (filterToggle) filterToggle.addEventListener("click", openFilter);
  if (filterClose) filterClose.addEventListener("click", closeFilter);
  if (overlay) overlay.addEventListener("click", closeFilter);

});